import { FunctionalComponent, h } from 'preact';
import classNames from 'classnames';

interface Props {
	merchantLogoUrl: string;
	className?: string;
}

const MerchantLogo: FunctionalComponent<Props> = ({ merchantLogoUrl, className }) => {
	return (
		<div
			data-testid="merchant-logo"
			className={classNames('merchant-logo', className)}
			style={{ backgroundImage: `url(${merchantLogoUrl})` }}
			aria-hidden="true"
		/>
	);
};

export default MerchantLogo;
